import { getKyivDateKey } from './getKyivDateParts'

const pad2 = (value) => String(value).padStart(2, '0')

const toIsoDate = (year, month, day) => {
  if (!isValidIsoParts(year, month, day)) {
    return null
  }

  return `${year}-${pad2(month)}-${pad2(day)}`
}

const isValidIsoParts = (year, month, day) => {
  const y = Number(year)
  const m = Number(month)
  const d = Number(day)

  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) {
    return false
  }

  if (m < 1 || m > 12 || d < 1 || d > 31) {
    return false
  }

  const date = new Date(Date.UTC(y, m - 1, d))

  return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d
}

const normalizeTwoDigitYear = (yearSuffix, contextYear) => {
  const century = Math.floor(contextYear / 100) * 100
  let year = century + Number(yearSuffix)

  if (year > contextYear + 5) {
    year -= 100
  }

  return year
}

const TITLE_DATE_PATTERNS = [
  {
    regex: /\b(\d{4})[-_](\d{2})[-_](\d{2})\b/g,
    parse: (match) => toIsoDate(match[1], match[2], match[3]),
  },
  {
    regex: /\b(\d{2})\.(\d{2})\.(\d{4})\b/g,
    parse: (match) => toIsoDate(match[3], match[2], match[1]),
  },
  {
    regex: /\b(\d{2})\.(\d{2})\.(\d{2})\b/g,
    parse: (match, contextYear) => {
      const year = normalizeTwoDigitYear(match[3], contextYear)
      return toIsoDate(year, match[2], match[1])
    },
  },
  {
    regex: /\b(\d{2})\.(\d{2})(?!\.?\d)\b/g,
    parse: (match, contextYear) => toIsoDate(contextYear, match[2], match[1]),
  },
]

export const stripDateFromCampaignTitle = (title = '') => {
  let result = String(title)

  TITLE_DATE_PATTERNS.forEach(({ regex }) => {
    result = result.replace(new RegExp(regex.source, regex.flags), ' ')
  })

  return result.replace(/\s+/g, ' ').trim()
}

export const parseDateFromCampaignTitle = (title = '', contextDate = new Date()) => {
  if (!title?.trim()) {
    return null
  }

  const contextYear = Number(getKyivDateKey(contextDate).split('-')[0])
  let lastMatch = null

  TITLE_DATE_PATTERNS.forEach(({ regex, parse }) => {
    const matcher = new RegExp(regex.source, regex.flags)
    let match = matcher.exec(title)

    while (match) {
      const isoDate = parse(match, contextYear)

      if (isoDate) {
        lastMatch = {
          isoDate,
          matchedText: match[0],
          index: match.index,
        }
      }

      match = matcher.exec(title)
    }
  })

  return lastMatch
}

export default parseDateFromCampaignTitle
